import { App as AntApp, ConfigProvider } from "antd";
import sk_SK from "antd/locale/sk_SK";
import i18next from "i18next";
import { I18nextProvider } from "react-i18next";
import { BrowserRouter } from "react-router";
import { createApiServiceInterceptors } from "../../common/api/apiServiceInterceptors";
import { ErrorBoundary } from "../components/boundaries/ErrorBoundary";
import { GoogleMapsApiProvider } from "../contexts/GoogleMapsApiContext";
import { ReactQueryProvider } from "../contexts/ReactQueryContext";
import { App } from "./App";

createApiServiceInterceptors();

export const Root = () => (
  <I18nextProvider i18n={i18next}>
    <ConfigProvider
      locale={sk_SK}
      tag={{ variant: "outlined", style: { marginInlineEnd: "var(--ant-margin-xs)" } }}
      table={{ style: { isolation: "isolate" } }}
      theme={{
        hashed: false,
        token: {
          screenLGMax: 1279,
          screenXL: 1280,
          screenXLMin: 1280,
        },
      }}
    >
      <ReactQueryProvider>
        <GoogleMapsApiProvider>
          <BrowserRouter>
            <ErrorBoundary>
              <AntApp notification={{ placement: "topRight", maxCount: 5 }} message={{ duration: 5 }}>
                <App />
              </AntApp>
            </ErrorBoundary>
          </BrowserRouter>
        </GoogleMapsApiProvider>
      </ReactQueryProvider>
    </ConfigProvider>
  </I18nextProvider>
);
